export default __webpack_public_path__ + "static/media/m-pesa-logo-red.e5f93483.png";